import { atom, atomEffect, swr } from '@exodus/headless-ui';
import { fromAmountAtom, fromAssetAtom, swapModeAtom, toAmountAtom, toAssetAtom, } from '../atoms/index.js';
import quoteAtom from '../atoms/quote.js';
import maxQuoteAtom from '../atoms/max-quote.js';
import { conversionByRate } from '@exodus/currency';
const MINER_FEE_USD = 2;
const minerFeeEstimation = atom((get, { selectors }) => {
    const asset = get(toAssetAtom);
    const fiatRates = get(selectors.rates.fiatRates);
    const rate = fiatRates[asset.ticker]?.priceUSD;
    if (!rate || !Number.isFinite(rate))
        return asset.currency.ZERO;
    const feeAmount = MINER_FEE_USD / rate;
    return asset.currency.defaultUnit(feeAmount);
});
const quoteEffect = atomEffect((get, set) => {
    const quote = get(swr(quoteAtom));
    const maxQuote = get(swr(maxQuoteAtom));
    const isExactIn = get(swapModeAtom) === 'ExactIn';
    const toAsset = get(toAssetAtom);
    const sourceAmount = get(isExactIn ? fromAmountAtom : toAmountAtom);
    const targetAmountAtom = isExactIn ? toAmountAtom : fromAmountAtom;
    const quoteData = quote.data;
    if (sourceAmount.isZero || (!quote.validating && !quoteData)) {
        return set(targetAmountAtom, undefined);
    }
    if (quoteData) {
        const targetAmount = isExactIn ? quoteData.toAmount : quoteData.fromAmount;
        set(targetAmountAtom, targetAmount);
        return;
    }
    if (maxQuote.data) {
        const { swapStrategy } = maxQuote.data;
        const sourceAsset = get(isExactIn ? fromAssetAtom : toAssetAtom);
        const targetAsset = get(isExactIn ? toAssetAtom : fromAssetAtom);
        const rate = isExactIn ? parseFloat(maxQuote.data.rate) : 1 / parseFloat(maxQuote.data.rate);
        const convert = conversionByRate(sourceAsset.currency, targetAsset.currency, rate);
        const fee = swapStrategy === 'direct' ? get(minerFeeEstimation) : toAsset.currency.ZERO;
        const prediction = isExactIn ? convert(sourceAmount).sub(fee) : convert(sourceAmount.add(fee));
        set(targetAmountAtom, prediction.clampLowerZero());
    }
});
export default quoteEffect;
